import Pricing from '@/apps/upgrade/Pricing.vue';
import { requireSeeker } from '../guards/authGuards';
import { redirectIfParentEmailVerificationRequiredForPricing } from '../guards/emailVerificationGuard';
import combineGuards from '../guards/helpers';

const upgradeRoutes = [
  {
    path: '/upgrade/pricing',
    name: 'upgrade-pricing',
    component: Pricing,
    // Variant B: EV before pricing; already-verified parents pass through.
    beforeEnter: combineGuards([requireSeeker, redirectIfParentEmailVerificationRequiredForPricing]),
  },
  {
    path: '/upgrade',
    redirect: (to) => ({ name: 'upgrade-pricing', query: to.query }),
  },
];

export default upgradeRoutes;
